import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from "ngx-spinner";
import { ApiService } from '../../services/api.service';
import { ApiAnalyticsService } from '../../services/api-analytics.service';
import { DataService } from '../../services/data.service';
import { URL_IMG } from '../../constants/general';

@Component({
  selector: 'app-options',
  templateUrl: './options.component.html',
  styleUrls: ['./options.component.scss'],
  host:{
    'class':'col forms-options-style d-flex justify-content-center'
  }
})
export class OptionsComponent implements OnInit {
  generalData:any;
  url_img = URL_IMG;
  constructor(private router:Router,
              private spinner: NgxSpinnerService,
              private api: ApiService,
              private apiAnalytics: ApiAnalyticsService,
              private data: DataService) 
  {    
    this.validateSession();
  }

  validateSession() {
    if( sessionStorage.getItem('general_data') ){
      this.generalData = JSON.parse( sessionStorage.getItem('general_data') );
      console.log(this.generalData);
    } else {
      this.router.navigate(['/registro']);
    }
  }

  ngOnInit(): void {
    window.scrollTo(0, 0);
    this.data.setStep('opciones');
  }

  previous() {
    this.router.navigate(['/registro']);
  }

  autonomousOpening() {
    this.apiAnalytics.gTag(`Landing | Registrate | Desicion | Autonomo`, 'Landing | Registrate | Desicion', 'Tres Pasos Bursanet','1');
    this.router.navigate(['/opciones/autonomo-identificacion']);
  }

  assistedOpening() {

    this.apiAnalytics.gTag(`Landing | Registrate | Desicion | Asistido`, 'Landing | Registrate | Desicion', 'Tres Pasos Bursanet','1');
    
    this.spinner.show();
    let body = {
      allDataForms: ` Nombre: ${this.generalData.cx_nombre}| Apellido Paterno: ${this.generalData.cx_apellido_p}| Apellido Materno: ${this.generalData.cx_apellido_m}| Correo: ${this.generalData.cx_correo}| Telefono Celular: ${this.generalData.int_telefono}| Folio: ${this.generalData.cx_folio}`,
      asunto: 'Contratos Bursanet: Solicitud de apertura asistida',
      cx_folio: this.generalData.cx_folio,
      plantilla: '3'
    };

    this.api.actionCntrtsAllSteps(body).subscribe((data: any) => {
      this.spinner.hide();
      this.apiAnalytics.gTagPixelCorto('#/opciones/asistido-thank-you-page');
      this.router.navigate(['/opciones/asistido-thank-you-page']);  
      this.prospectClientRegistration();
    }, error => {
      this.spinner.hide();
      console.log('Error: ', error);
    });

  }

  prospectClientRegistration() {

    this.spinner.show();

    this.api.getToken().subscribe((dataToken: any) => {
      let recordTypeId = '0122C0000001F1nQAE';
      if(window.location.origin.indexOf("bursanet.mx") == 12) {
        recordTypeId = '0125e000000OdVvAAK';
      }

      let bodyProspect = {
        "adressB__c": "",
        "adressTypeB__c": "",
        "apellido_Materno__c": this.generalData.cx_apellido_m,
        "apellido_MaternoB__c": "",
        "asistencia__c": "true",
        "birthdateB__c": "",
        "calleB__c": "",
        "cityB__c": "",
        "colB__c": "",
        "company": "",
        "countryB__c": "",
        "curp__C": "",
        "document__c": "",
        "dom_Actual__c": "",
        "email": this.generalData.cx_correo,
        "enb__c": "",
        "estado_Civil__c": "",
        "firstName": this.generalData.cx_nombre,
        "firstNameB__c": "",
        "folio__c": this.generalData.cx_folio,
        "inb__c": "",
        "lastName": this.generalData.cx_apellido_p,
        "lastNameB__c": "",
        "leadSource": "BURSANET",
        "municipioB__c": "",
        "parentesco__c": "",
        "pcb__c": "",
        "pdr__c": "true",
        "postalCode": "00000",
        "profesion__c": "",
        "profesion_esp__c": "",
        "puesto__c": "",
        "recordTypeId": recordTypeId,
        "rfc__C": "",
        "stateB__c": "",
        "status": "true"
      };
      
      this.api.prospectClientRegistration(bodyProspect, dataToken.accessToken, this.generalData.int_telefono).subscribe((data: any) => {
        this.spinner.hide();
        console.log(data);
      }, error => {
        this.spinner.hide();
        console.log('Error: ', error);
      });

    }, error => {
      this.spinner.hide();
      console.log('Error: ', error);
    });
  }

}
